import { Box } from '@mui/joy';
import { useState } from 'react';

import { PartSearch } from 'bom/components';
import { VendorSearch } from 'contacts/components/VendorSearch';

import { SearchScope } from './enums';
import { SearchScopeSelector } from './SearchScopeSelector';

export const GlobalSearch = () => {
  const [scope, setScope] = useState(SearchScope.PARTS);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: 500,
        border: '1px solid',
        borderColor: 'neutral.300',
        borderRadius: '3px',
        backgroundColor: 'background.surface',
        overflow: 'visible',
        position: 'relative',
      }}
    >
      <SearchScopeSelector value={scope} onChange={setScope} />
      {scope === SearchScope.PARTS && <PartSearch />}
      {scope === SearchScope.VENDORS && <VendorSearch />}
    </Box>
  );
};
